<template>
  <div :class="$style.root">
    <div :class="$style.source">
      {{ attributes?.source }}{{ attributes?.source && attributes?.datePosted ? ', ' : '' }}
      <CoreDateTimeRangeComponent v-if="attributes?.datePosted" :dateStart="attributes?.datePosted" format="MMMM YYYY" />
    </div>

    <a :href="attributes?.sourceUrl" target="_blank" :class="$style.title" :data-overflow-hidden="titleOneLine ? '' : null">
      {{ attributes?.title?.trim() }}
    </a>

    <CoreDownloadsComponent :downloads="attributes?.files?.data" />

    <SharedPressRelationComponent
      :attributes="attributes"
      :class="$style.relation"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  titleOneLine: {
    type: Boolean,
    default: false,
  }
})

const getAttributes = baseStrapiGetAttributes
const localizedData = baseStrapiGetLocalizedData(props.data)
const attributes = baseStrapiGetAttributes(localizedData)
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
}

.source {
  composes: font-helvetica font-size-small from global;
}

.title {
  composes: font-size-default reset-link from global;
}

.title[data-overflow-hidden] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  line-height: 1;
  padding-top: .2em;
}

.title:not(:hover)[href]::first-letter {
  text-decoration-line: underline;
}

.title[href]:hover {
  text-decoration-line: underline;
}

.relation {
}
</style>
